import { create } from 'zustand'

interface AvatarState {
  isThereAvatar: boolean
  activeAvatarModal: boolean
  skippedAvatarBanner: boolean
  setSkippedAvatarBanner: (skippedAvatarBanner: boolean) => void
  setIsThereAvatar: (isThereAvatar: boolean) => void
  setActiveAvatarModal: (activeAvatarModal: boolean) => void
}

export const useAvatarStore = create<AvatarState>()((set) => ({
  isThereAvatar: true,
  activeAvatarModal: false,
  skippedAvatarBanner: false,
  setSkippedAvatarBanner: (skippedAvatarBanner: boolean) => set({ skippedAvatarBanner }),
  setActiveAvatarModal: (activeAvatarModal: boolean) => set({ activeAvatarModal }),
  setIsThereAvatar: (isThereAvatar: boolean) => set({ isThereAvatar }),
}))
